import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Query pulse
export const query = graphql(`
    query PulseQuery($id: ID!) {
        pulse(id: $id) {
            id
            question1
            question2
        }
    }
`);
export type IPulse = ResultOf<typeof query>["pulse"];

// Submit pulse mutation
export const mutation = graphql(`
    mutation PulseSubmitMutation($id: ID!, $answer1: String!, $answer2: String) {
        pulseSubmit(id: $id, answer1: $answer1, answer2: $answer2) {
            error
        }
    }
`);
